export const deClientPortalTaskOverviewPagePages = {
    taskOverviewPage: {
        search: 'Aufgabe suchen',
        assignee: 'Zuständig',
        currentUserSuffix: ' (Ich)',
        noUsers: 'Keine Nutzer gefunden',
        noOrders: 'Keine Aufträge gefunden',
        noPortfolios: 'Keine Portfolios gefunden',
        team: 'Team',
        noTeams: 'Keine Teams gefunden',
        resetFilters: 'Alle Filter zurücksetzen',
        showDone: 'Abgeschlossene anzeigen',
        loading: 'Wird geladen...',
        sort: {
            dueDateAscending: 'Deadline (aufsteigend)',
            dueDateDescending: 'Deadline (absteigend)',
            titleAscending: 'Aufgabentitel (A-Z)',
            titleDescending: 'Aufgabentitel (Z-A)',
        },
        table: {
            title: 'Titel',
            team: 'Team',
            deadline: 'Deadline',
            remaining: 'Verbleibend',
            entries_one: '{{count}} Eintrag',
            entries_other: '{{count}} Einträge',
            selectedEntries_one: '{{selectedCount}} von {{totalCount}} Eintrag ausgewählt',
            selectedEntries_other: '{{selectedCount}} von {{totalCount}} Einträgen ausgewählt',
            pageLabel: '{{page}} von {{pageCount}} Seiten',
            emptyFiltered: 'Keine Einträge zu Ihrer Suche',
            empty: 'Keine Einträge vorhanden',
            remainingToday: 'Heute',
            remainingDays_one: '{{count}} Tag',
            remainingDays_other: '{{count}} Tage',
            remainingOverdueDays_one: '{{count}} Tag überfällig',
            remainingOverdueDays_other: '{{count}} Tage überfällig',
            remainingOverMaxDays_one: 'Mehr als {{count}} Tag',
            remainingOverMaxDays_other: 'Mehr als {{count}} Tage',
            actions: {
                edit: 'Eintrag bearbeiten',
                delete: 'Eintrag löschen',
                ariaLabel: 'Optionen für Zeile {{rowIndex}}',
            },
        },
    },
}
